import { api } from "@/http/api-client"

import type { TChangelogTag, TListTagsResponse } from "./types"

export type TListTagsParams = {
  serviceId: string
  organizationSlug: string
}

export function listTags(params: TListTagsParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TListTagsResponse>(
    `/changelog/services/${params.serviceId}/tags?${searchParams.toString()}`,
  )
}

export type TCreateTagParams = {
  serviceId: string
  name: string
  color: string
  organizationSlug: string
}

export function createTag(params: TCreateTagParams) {
  const { serviceId, ...body } = params
  return api.post<TChangelogTag>(
    `/changelog/services/${serviceId}/tags`,
    { json: body },
  )
}

export type TUpdateTagParams = {
  serviceId: string
  tagId: string
  name?: string
  color?: string
  organizationSlug: string
}

export function updateTag(params: TUpdateTagParams) {
  const { serviceId, tagId, ...body } = params
  return api.patch<TChangelogTag>(
    `/changelog/services/${serviceId}/tags/${tagId}`,
    { json: body },
  )
}

export type TDeleteTagParams = {
  serviceId: string
  tagId: string
  organizationSlug: string
}

export function deleteTag(params: TDeleteTagParams) {
  return api.delete(
    `/changelog/services/${params.serviceId}/tags/${params.tagId}`,
    { json: { organizationSlug: params.organizationSlug } },
  )
}
